import { GetOrgId, GetUserId } from "utility";
import AxiosGetForApiWrapper from "utility/apiWrapperHelper";

export const GetAllBanks = () =>
  AxiosGetForApiWrapper(`/api/v1/org/${GetOrgId()}/bank_account/?user_id=${GetUserId()}`);
